"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.todayString = exports.timestampToDate = exports.timestampStringFromDate = exports.timestampString = exports.parseDayString = exports.getTimestampDifferenceInSeconds = exports.getDifferenceInHours = exports.getDateDifference = exports.dayString = void 0;
const todayString = (separator = "-") => dayString(new Date(), separator);
exports.todayString = todayString;
const dayString = (date, separator = "-") => {
  return `${date.getFullYear()}${separator}${String(date.getMonth() + 1).padStart(2, '0')}${separator}${String(date.getDate()).padStart(2, '0')}`;
};
exports.dayString = dayString;
const timestampString = (separator = "-") => {
  var d = new Date();
  return `${d.getFullYear()}${separator}${String(d.getMonth() + 1).padStart(2, '0')}${separator}${String(d.getDate()).padStart(2, '0')}${separator}${String(d.getHours()).padStart(2, '0')}${separator}${String(d.getMinutes()).padStart(2, '0')}${separator}${String(d.getSeconds()).padStart(2, '0')}${separator}${String(d.getMilliseconds()).padStart(3, '0')}`;
};
exports.timestampString = timestampString;
const timestampToDate = (timestamp, separator = "-") => {
  var _parts$, _parts$2, _parts$3, _parts$4, _parts$5, _parts$6, _parts$7;
  const parts = timestamp.split(separator);
  const year = parseInt((_parts$ = parts[0]) !== null && _parts$ !== void 0 ? _parts$ : "0");
  const month = parseInt((_parts$2 = parts[1]) !== null && _parts$2 !== void 0 ? _parts$2 : "0") - 1;
  const day = parseInt((_parts$3 = parts[2]) !== null && _parts$3 !== void 0 ? _parts$3 : "0");
  const hour = parseInt((_parts$4 = parts[3]) !== null && _parts$4 !== void 0 ? _parts$4 : "0");
  const minute = parseInt((_parts$5 = parts[4]) !== null && _parts$5 !== void 0 ? _parts$5 : "0");
  const second = parseInt((_parts$6 = parts[5]) !== null && _parts$6 !== void 0 ? _parts$6 : "0");
  const millisecond = parseInt((_parts$7 = parts[6]) !== null && _parts$7 !== void 0 ? _parts$7 : "0");
  return new Date(year, month, day, hour, minute, second, millisecond);
};
exports.timestampToDate = timestampToDate;
const timestampStringFromDate = (date, separator = "-") => {
  return `${date.getFullYear()}${separator}${String(date.getMonth() + 1).padStart(2, '0')}${separator}${String(date.getDate()).padStart(2, '0')}${separator}${String(date.getHours()).padStart(2, '0')}${separator}${String(date.getMinutes()).padStart(2, '0')}${separator}${String(date.getSeconds()).padStart(2, '0')}${separator}${String(date.getMilliseconds()).padStart(3, '0')}`;
};
exports.timestampStringFromDate = timestampStringFromDate;
const parseDayString = (day, separator = "-") => {
  var _parts$8, _parts$9, _parts$10;
  var d = new Date();
  const parts = day.split(separator);
  d.setFullYear(parseInt((_parts$8 = parts[0]) !== null && _parts$8 !== void 0 ? _parts$8 : "0"));
  d.setMonth(parseInt((_parts$9 = parts[1]) !== null && _parts$9 !== void 0 ? _parts$9 : "0") - 1);
  d.setDate(parseInt((_parts$10 = parts[2]) !== null && _parts$10 !== void 0 ? _parts$10 : "0"));
  return d;
};
exports.parseDayString = parseDayString;
const getDateDifference = (day1, day2, separator = "-") => {
  return Math.abs(Math.ceil((parseDayString(day2).getTime() - parseDayString(day1).getTime()) / (1000 * 60 * 60 * 24)));
};
exports.getDateDifference = getDateDifference;
const getDifferenceInHours = (day1, day2, separator = "-") => {
  return Math.abs(Math.ceil((parseDayString(day2).getTime() - parseDayString(day1).getTime()) / (1000 * 60 * 60)));
};
exports.getDifferenceInHours = getDifferenceInHours;
const getTimestampDifferenceInSeconds = (timestamp1, timestamp2, separator = "-") => {
  const date1 = timestampToDate(timestamp1, separator);
  const date2 = timestampToDate(timestamp2, separator);
  const differenceInSeconds = Math.abs(Math.floor((date2.getTime() - date1.getTime()) / 1000));
  return differenceInSeconds;
};
exports.getTimestampDifferenceInSeconds = getTimestampDifferenceInSeconds;